import { ShiftManagementSelectableEmployeesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

type PermissionAction = 'read' | 'create'

// Employees USING SHIFT MANAGEMENT + that I have permissions to read/create shifts
const useSelectableEmployees = (
  startAt: string,
  endAt: string,
  action: PermissionAction = 'create'
) => {
  // Cache-first to avoid fetching the same data multiple times
  // because SelectableEmployees is stable and doesn't change frequently.
  //
  // This returns employees using shiftmanagement, but I might not have permissions for them
  const { data, loading } = useQuery(ShiftManagementSelectableEmployeesDocument, {
    fetchPolicy: 'cache-first',
    variables: {
      startAt,
      endAt,
    },
  })

  const employeesPermissions = data?.shiftManagement.employeesPermissions
  const selectableEmployeeIds = employeesPermissions?.reduce<number[]>((acc, employee) => {
    if (action === 'read' || employee.permissions?.create) {
      acc.push(employee.id)
    }
    return acc
  }, [])

  return { loading, selectableEmployeeIds: selectableEmployeeIds ?? [] }
}

export { useSelectableEmployees }
